import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStop } from "@fortawesome/free-solid-svg-icons";
import { getAllWorkHistoryByID, updateWorkHistoryThunk } from "../../Slices/orderSlice";
import { addLatestReports } from "../../Slices/employeereportslice";
import { updateBreakAsync } from "../../Slices/attendenceSlice";
import { fetchAllRecordsAsync } from "../../Slices/Thunk/LoginThunk";
import { getAllLeadWorkHistory } from "../../Slices/salesSlice";
import { Starttask, resetPopupCount } from "../../Slices/timerslice";

/**
 * StopTaskButton — tray button shown while a task is running. Stops it (returns
 * to "Available"), mirroring the legacy Timer's Stop handler EXACTLY by reusing
 * the same thunks (work-history, break out, reports). No new business logic is
 * invented — this only relocates the existing Stop into the Webtop tray.
 *
 * Kept in its own module so SystemTray tests can mock it (it pulls in slices
 * with ESM deps Jest can't transform).
 */

// Mirrors the local helper in components/Timer.jsx.
const formatDateTime = (receivedDate) => {
  const now = new Date(receivedDate);
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear();
  let hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  if (hours > 12) hours -= 12;
  else if (hours === 0) hours = 12;
  hours = String(hours).padStart(2, "0");
  return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
};

const StopTaskButton = () => {
  const dispatch = useDispatch();
  const [busy, setBusy] = useState(false);

  const specificEmployee = useSelector((s) => s?.loginUserInfo?.loginUserDetails) || {};
  const department = useSelector((s) => s?.timer?.department);
  const task = useSelector((s) => s?.timer?.task);
  const allRecords = useSelector((s) => s?.Attendence?.AllRecords) || [];
  const RequestInfo = useSelector((s) => s?.orders?.singleOrder);
  const SalesInfo = useSelector((s) => s?.sales?.sale);
  const userid = specificEmployee?.id;

  const onStop = async () => {
    if (busy) return;
    setBusy(true);
    const now = Date.now();
    const payload = { task: "Available", time: now, department: "", requestId: "" };
    const Reportpayload = {
      userId: userid,
      employeeName: `${specificEmployee.firstname || ""} ${specificEmployee.lastname || ""}`.trim(),
      emailId: specificEmployee.email,
      requestId: "N/A",
      reportingTo: specificEmployee.reportingManager || "N/A",
      clientName: "Blueplanit",
      requestIds: "N/A",
      processType: "",
      taskType: "Available",
      billable: "No",
      service: "N/A",
      requestCompleted: "N/A",
      startTime: now.toString(),
      startingTime: formatDateTime(now),
      status: "Pending",
      endTime: "",
      overrideHistory: [],
      department,
    };
    try {
      if (task === "Break") {
        const breakIn = localStorage.getItem("breakIn");
        if (breakIn) {
          const attendanceRecord = allRecords.find(
            (r) => r.status === true && r.punchOut === null
          );
          if (attendanceRecord?.id) {
            await dispatch(
              updateBreakAsync({ attendanceId: attendanceRecord.id, breakIn, breakOut: now.toString() })
            );
            await dispatch(fetchAllRecordsAsync({ userId: userid }));
            localStorage.removeItem("breakIn");
          }
        }
      }
      const valuesObject = {
        userId: userid,
        emailId: specificEmployee.email,
        requestId: "",
        clientName: "Blueplanit",
        processType: "",
        taskType: "Available",
        email: "",
        subject: "",
        body: "",
        startTime: now.toString(),
        endTime: "",
        department,
      };
      await dispatch(updateWorkHistoryThunk(valuesObject)).unwrap();
      dispatch(addLatestReports(Reportpayload));
      if (RequestInfo?.id) dispatch(getAllWorkHistoryByID(RequestInfo.id));
      if (SalesInfo?.id) dispatch(getAllLeadWorkHistory(SalesInfo.id));
      localStorage.removeItem("department");
      localStorage.removeItem("task");
      localStorage.removeItem("requestId");
      window.electronAPI?.clearActiveRequest?.();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Error stopping task:", err);
    }
    localStorage.setItem("time", now);
    dispatch(resetPopupCount());
    dispatch(Starttask(payload));
    setBusy(false);
  };

  return (
    <button
      type="button"
      className="webtop-tray__btn webtop-tray__stop"
      title="Stop current task (go Available)"
      aria-label="Stop task"
      onClick={onStop}
      disabled={busy}
    >
      <FontAwesomeIcon icon={faStop} />
    </button>
  );
};

export default StopTaskButton;
